import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {
    MeetingForLandingPage as Meeting,
    GetMeetingsForLandingPages as GetMeetingsForLandingPagesQuery,
} from 'nutshell-graphql-types';

import GET_MEETINGS_FOR_LANDING_PAGES from '../queries/get-meetings-for-landing-pages.graphql';

export function useGetMeetingsForLandingPages(): {
    meetings: Meeting[];
    isLoading: boolean;
    isFirstLoad: boolean;
    error: string | null | undefined;
} {
    const {data, error, loading, networkStatus} = useQuery<
        GetMeetingsForLandingPagesQuery,
        Record<any, any>
    >(GET_MEETINGS_FOR_LANDING_PAGES, {
        fetchPolicy: 'cache-and-network',
    });

    return {
        meetings: data ? data.meetings : [],
        isLoading: loading,
        isFirstLoad: isFirstLoad(networkStatus),
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
